import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-add-result',
  templateUrl: './add-result.component.html',
  styleUrl: './add-result.component.scss'
})
export class AddResultComponent {
  constructor(private location: Location){}
  goBackToPrevPage(){
    this.location.back();
  }
}
